export default __webpack_public_path__ + "static/media/info.0830476d.svg";